import { IJwtProvider } from 'modules/authentication/domain/providers';

import JwtDecodeJwtProvider from './implementations/JwtDecodeJwtProvider';

let instance: IJwtProvider | null = null;

export default function makeJwtProvider() {
  if (!instance) {
    instance = new JwtDecodeJwtProvider();
  }

  return instance;
}
